type CallEvent = Record<string, unknown>

const text = (value: unknown) => String(value ?? '').trim()

export function getCallPersonName(call: CallEvent = {}) {
  return text(call.pers_name)
    || [text(call.pers_firstname), text(call.pers_lastname)].filter(Boolean).join(' ')
}

export function shouldShowDesktopCallNotification({
  eventType,
  permission,
  documentHidden,
  windowFocused,
}: {
  eventType?: unknown
  permission?: NotificationPermission | string
  documentHidden?: boolean
  windowFocused?: boolean
}) {
  return text(eventType) === 'ringing'
    && permission === 'granted'
    && (documentHidden === true || windowFocused === false)
}

export function buildDesktopCallNotification(call: CallEvent = {}) {
  const name = getCallPersonName(call)
  const number = text(call.call_number)
  const extension = text(call.ringing_extension)
  const details = [
    number || 'Numara alınamadı',
    extension ? `Çalan dahili: ${extension}` : '',
  ].filter(Boolean)

  return {
    title: name ? `Gelen arama · ${name}` : 'Gelen arama',
    body: details.join('\n'),
    tag: `incoming-call-${text(call.call_uuid) || number || 'unknown'}`,
  }
}

export function getCallEventLabel(eventType: unknown) {
  return ({
    ringing: 'Çalıyor',
    answer: 'Cevaplandı',
    hangup: 'Kapandı',
    user_hangup: 'Kapandı',
  } as Record<string, string>)[text(eventType)] || 'Çağrı olayı'
}

export function formatCallEventTime(value: unknown, locale = 'tr-TR') {
  const date = new Date(text(value))
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date)
}
